<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen has-text-centered">
            <form action class="box">
              <b-field label="Email">
                <b-input v-model="form.email" @keyup.native.enter="login"></b-input>
              </b-field>

              <b-field label="Password">
                <b-input type="password" v-model="form.password" @keyup.native.enter="login"></b-input>
              </b-field>

              <b-button type="is-primary" @click="login">Login</b-button>
              <br/><br/>
              <b-button @click="resetPwd">Reset password</b-button>
            </form>
            <b-message title="Error" type="is-danger" v-if="this.error">{{this.error}}</b-message>
            <b-message title="Success" type="is-success" v-if="this.success">{{this.success}}</b-message>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: "",
      success: ""
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(() => {
          this.$router.replace({ name: "home" });
        })
        .catch(err => {
          this.error = err.message;
        });
    },
    resetPwd () {
      if (!this.form.email) {
        this.error = 'Fill the email field and then click again the reset password button'
        return
      }
      firebase
        .auth()
        .sendPasswordResetEmail(this.form.email)
        .then(() => {
          this.success  = 'The email for the password reset has been sent! (Check your spam folder if you don\'t get the email)'
        })
        .catch(err => {
          console.log('ollaaa')
          this.error = err.message;
        });
    }
  }
};
</script>
